import RestauranteImpressoraService from "@/services/RestauranteImpressoraService";

export const restauranteImpressora = {
  namespaced: true,
  state: {
    restauranteImpressora: {},
  },
  actions: {
    getRestauranteImpressoraOData({ commit }, payload) {
      return RestauranteImpressoraService.getRestauranteImpressoraOData(
        payload
      ).then(
        (restauranteImpressora) => Promise.resolve(restauranteImpressora),
        (error) => Promise.reject(error)
      );
    },
    putRestauranteImpressora({ commit }, payload) {
      return RestauranteImpressoraService.putRestauranteImpressora(
        payload
      ).then(
        (restauranteImpressora) => Promise.resolve(restauranteImpressora),
        (error) => Promise.reject(error.response.data)
      );
    },
    deleteRestauranteImpressora({ commit }, payload) {
      return RestauranteImpressoraService.deleteRestauranteImpressora(
        payload
      ).then(
        (response) => Promise.resolve(response),
        (error) => Promise.reject(error.response.data)
      );
    },
    vincularProdutos({ commit }, payload) {
      return RestauranteImpressoraService.vincularProdutos(
        payload.id,
        payload.ids
      ).then(
        (response) => Promise.resolve(response),
        (error) => Promise.reject(error.response.data)
      );
    },
    vincularGrupos({ commit }, payload) {
      return RestauranteImpressoraService.vincularGrupos(
        payload.id,
        payload.ids
      ).then(
        (response) => Promise.resolve(response),
        (error) => Promise.reject(error.response.data)
      );
    },
  },
  mutations: {},
};

export default restauranteImpressora;
